import { RouterProvider } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import React, { useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, initializeMsal } from '~/util/msalConfig';
import './index.css';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorScreen } from './shared/ErrorScreen';
import { router } from './AppRouter';
import { LoadingScreen } from './shared/LoadingScreen';

function App() {
	const [msalInitialized, setMsalInitialized] = useState(false);

	useEffect(() => {
		// Initialize MSAL and wait for it to complete before rendering
		initializeMsal().then(() => {
			setMsalInitialized(true);
		});
	}, []);

	if (!msalInitialized) {
		return <LoadingScreen message="Initializing authentication..." />;
	}

	return (
		<React.StrictMode>
			<ErrorBoundary fallbackRender={ErrorScreen}>
				<MsalProvider instance={msalInstance}>
					<NuqsAdapter
						defaultOptions={{
							clearOnDefault: true
						}}
					>
						<RouterProvider
							router={router}
							future={{
								v7_startTransition: true
							}}
						/>
					</NuqsAdapter>
				</MsalProvider>
			</ErrorBoundary>
		</React.StrictMode>
	);
}

export default App;
